import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, Output } from "@angular/core";

import { ServiceStock } from "../service-stock.service";

@Component({
  selector: "ux-app-start-card",
  templateUrl: "./element.component.html",
  styleUrls: ["./element.component.scss"],
})
export class UXAppStartCardComponent implements AfterViewInit, OnDestroy {
  @Input("card") card: any;
  @Input("cardIndex") cardIndex: any;
  @Input("selectedCardIndex") selectedCardIndex: any;
  @Input("activeCardIndex") activeCardIndex: any;

  @Output("onswipeleft") swipeLeftEventEmitter = new EventEmitter<any>();
  @Output("onswiperight") swipeRightEventEventEmitter = new EventEmitter<any>();
  @Output("onpanleft") panLeftEventEmitter = new EventEmitter<any>();
  @Output("onpanright") panRightEventEmitter = new EventEmitter<any>();
  @Output("onpanstart") panStartEventEmitter = new EventEmitter<any>();
  @Output("onpanend") panEndEventEmitter = new EventEmitter<any>();
  @Output("ontouchstart") touchStartEventEmitter = new EventEmitter<any>();
  @Output("ontouchend") touchEndEventEmitter = new EventEmitter<any>();
  constructor(private services: ServiceStock) {}

  ngAfterViewInit() {}

  ngOnDestroy() {}

  swipeLeftHandler($event) {
    if (this.services.isMobile()) {
      this.swipeLeftEventEmitter.emit($event);
    }
  }

  swipeRightHandler($event) {
    if (this.services.isMobile()) {
      this.swipeRightEventEventEmitter.emit($event);
    }
  }

  touchStartHandler($event) {
    if (this.services.isMobile()) {
      this.touchStartEventEmitter.emit($event);
    }
  }

  touchEndHandler($event) {
    if (this.services.isMobile()) {
      this.touchEndEventEmitter.emit($event);
    }
  }

  panStartHandler($event) {
    if (this.services.isMobile()) {
      this.panStartEventEmitter.emit($event);
    }
  }

  panEndHandler($event) {
    if (this.services.isMobile()) {
      this.panEndEventEmitter.emit($event);
    }
  }

  panLeftHandler($event) {
    if (this.services.isMobile()) {
      this.panLeftEventEmitter.emit($event);
    }
  }

  panRightHandler($event) {
    if (this.services.isMobile()) {
      this.panRightEventEmitter.emit($event);
    }
  }

  isActiveCard(index) {
    return index == this.activeCardIndex;
  }

  isBeforeActiveCard(index) {
    return index == this.activeCardIndex - 1;
  }

  isAfterActiveCard(index) {
    return index == this.activeCardIndex + 1;
  }
}
